import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_get_materials_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { filters: { owner?: string[], project?: string[], status?: string[], lookup?: string[], global_material_name?: string[], material_name?: string[], material_group?: string[], material_id?: number[], fulfilled_from?: string, fulfilled_to?: string } }): Promise<{ materials?: $frontendTypes.FootprintApiManager.public_material[], errors?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.filters)) {
      $missingRequiredInParams.push('\'filters\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/materials/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

